import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { LoadingService } from "@services/loading.service";

@Component({
    selector: "loading",
    imports: [CommonModule, TranslocoPipe],
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.css"]
})
export class LoadingComponent {
    private loadingService = inject(LoadingService);

    loading$ = this.loadingService.loading$;
}
